const NAMESPACE = "filteredSelectOptions";
const KEYS = {
    clearSelectionAriaLabel: "clearSelectionAriaLabel"
};
const MESSAGES = {
    [KEYS.clearSelectionAriaLabel]: {
        value: "Clear Selection",
        comment: "Aria Label for the Clear Selection button"
    }
};
export { KEYS, NAMESPACE, MESSAGES };
